import { render } from "./rep022.vue?vue&type=template&id=3139929e&scoped=true"
import script from "./rep022.vue?vue&type=script&lang=js"
export * from "./rep022.vue?vue&type=script&lang=js"

import "./rep022.vue?vue&type=style&index=0&id=3139929e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3139929e"]])

export default __exports__